import { ReactNode } from "react"
import { Block, BlockProps, Button, useStyletron } from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import {
  earnImage,
  poolsImage,
  vaultsImage,
  voteImage,
} from "#/assets/defi-ecosystem"
import ProductCard from "#/shared/components/ProductCard"
import {
  ENABLE_GOVERNANCE_PAGE,
  ENABLE_VAULT_PAGE,
  IS_MEZO_MAINNET,
  routes,
  VAULTS_DAILY_MATS_REWARD,
} from "#/shared/constants"
import { separateThousandsWithComaRegExp } from "#/shared/utils"

const DEFI_ECOSYSTEM_PRODUCTS: {
  title: string
  description: ReactNode
  image: string
  route?: string
  withTagMessage: boolean
  isEnabled?: boolean
}[] = [
  {
    title: "Vaults",
    image: vaultsImage,
    route: routes.EXPLORE_VAULTS,
    isEnabled: ENABLE_VAULT_PAGE,
    withTagMessage: IS_MEZO_MAINNET && !ENABLE_VAULT_PAGE,
    description: `${
      IS_MEZO_MAINNET
        ? "Deposit to access yield on your Bitcoin."
        : "Discover Mezo Vaults on mainnet."
    }\nEarn up to ${separateThousandsWithComaRegExp(
      VAULTS_DAILY_MATS_REWARD.toString(),
    )} mats daily and more${IS_MEZO_MAINNET ? "." : "!"}`,
  },
  {
    title: "Earn",
    image: earnImage,
    route: routes.EARN,
    isEnabled: ENABLE_GOVERNANCE_PAGE,
    withTagMessage: !ENABLE_GOVERNANCE_PAGE,
    description:
      "Lock your BTC and earn rewards for securing the Mezo network.",
  },
  {
    title: "Pools",
    image: poolsImage,
    withTagMessage: true,
    description:
      "Provide and manage liquidity while earning ecosystem gauge rewards or trading fees from pools.",
  },
  {
    title: "Vote",
    image: voteImage,
    withTagMessage: true,
    description:
      "Gain direct governance rights over protocol decisions to shape Mezo’s ecosystem and earn rewards.",
  },
]

export default function DeFiEcosystem(props: BlockProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: theme.sizing.scale300,
        [theme.mediaQuery.large]: {
          gridTemplateColumns: "repeat(2, 1fr)",
        },
      })}
      {...props}
    >
      {DEFI_ECOSYSTEM_PRODUCTS.map(
        ({ title, description, image, isEnabled, route, withTagMessage }) => (
          <ProductCard
            key={title}
            headerImage={image}
            title={title}
            description={description}
            tagMessage={withTagMessage ? "Coming Soon" : undefined}
            {...(isEnabled &&
              route && {
                endEnhancer: () => (
                  <Button
                    $as={Link}
                    kind="secondary"
                    shape="pill"
                    size="small"
                    href={route}
                  >
                    Discover
                  </Button>
                ),
              })}
          />
        ),
      )}
    </Block>
  )
}
